export default __webpack_public_path__ + "static/media/2.004b1923.jpg";